
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIceberg as ObiIcebergElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-iceberg.js';
 
 
 

 
 export const ObiIceberg = createComponent({
   react: React,
   tagName: 'obi-iceberg',
   elementClass: ObiIcebergElement,
   events: {
     
   }
  });
 
 